import ModifierComboParentButton from "./ModifierComboParentButton.js";

export default function ModifierComboParentContainer(props) {
    // Returns Modifier Category containing Modifier Combo & button

    return (
        <>
            <div className="col-12 wo-opt__head">
                <span className="wo-opt__name">Add Combo</span>
            </div>
            <ModifierComboParentButton
                modifierCategoryDetails={props.modifierCategoryDetails}
                productFormDataMods={props.productFormDataMods}
                comboFormData={props.comboFormData}
                handleModifierComboSelect={props.handleModifierComboSelect}
                handleRemoveModifierComboFromProduct={props.handleRemoveModifierComboFromProduct}
                modCatId={props.modCatId}
                addToCartError={props.addToCartError}
                currentLocation={props.currentLocation}
            />
            
        </>
    )
}